<template>
  <div class="customer">
    <v-container class="d-flex-column">
      <detail-card
        title="Πελάτης"
        api="customers/"
        :cid="this.$route.params.id"
      >
  <template v-slot:tabsleft>
      <v-btn
        color="primary"
        dark
        @click="paymdialog=true"
      >
      <v-icon>mdi-cash-register</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        dark
        @click="reminderDialog=true"
      >
      <v-icon>mdi-cash-clock</v-icon>
      </v-btn>
      <v-dialog v-model="reminderDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">Αποστολή ειδοποίησης;</v-card-title>
          <v-card-text>
            Είστε σίγουροι πως θέλετε να στείλετε ειδοποίηση στον πελάτη;
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="reminderDialog = false">Ακυρωση</v-btn>
            <v-btn color="primary" text @click="sendReminder">Επιβεβαιωση</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
     <payment-dialog :cid="$route.params.id" :dialog.sync="paymdialog" apipath="customers/debits" />
     <health-score-dialog
        v-model="healthDialog"
        :customer-id-prop="customer_id"
        button-text=""
        button-color="primary"
        @export-health-report="downloadReport"
     />
  </template>
        <template v-slot:tabsright>
        </template>
      </detail-card>
      <v-sheet
      color="white"
      class="ma-3"
      elevation="2">
       <v-tabs show-arrows>
          <v-tab replace :to="{ name: 'customer-info' }">Πληρωμες</v-tab>
          <v-tab replace :to="{ name: 'customer-invoices' }">Τιμολογια</v-tab>
          <v-tab replace :to="{ name: 'customer-quotes' }">Προσφορες</v-tab>
          <v-tab replace :to="{ name: 'customer-vehicles' }">Οχηματα</v-tab>
          <v-tab replace :to="{ name: 'customer-line-items' }">Γραμμες Τιμολογιων</v-tab>
          <v-tab replace :to="{ name: 'customer-repair-items' }">Ανταλλακτικα</v-tab>
          <v-tab replace :to="{ name: 'customer-preorders' }">προπαραγγελίες</v-tab>
          <v-tab replace :to="{ name: 'customer-repairs' }">Επισκευες</v-tab>
          <v-tab replace :to="{ name: 'customer-documents' }">Εγγραφα</v-tab>
          <v-tab replace :to="{ name: 'customer-balance' }">Οικονομικά</v-tab>
          <v-tab replace :to="{ name: 'customer-sales' }">Πωλήσεις</v-tab>
          <v-tab replace :to="{ name: 'customer-contacts' }">Επαφες</v-tab>
        </v-tabs>
      </v-sheet>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import DetailCard from "../../components/DetailCard.vue";
import PaymentDialog from "../../components/PaymentDialog.vue";
import HealthScoreDialog from '@/components/HealthScoreDialog.vue';

export default {
  components: {
    DetailCard,
    PaymentDialog,
    HealthScoreDialog,
  },
  data() {
    return {
      paymdialog: false,
      reminderDialog: false,
      healthDialog: false,
      customer_id: this.$route.params.id,
     // healthData: [],
    };
  },

  async mounted() {
    //this.healthData = await this.fetchHealthScore(this.customer_id);
  },

  async created() {
  },
  methods: {
    async sendReminder() {
        await this.$api.get("/customers/debits/balance-reminder/"+this.customer_id);

    },
  /*
  async fetchHealthScore(id) {
      // const response = await this.$api.get(`/customers/health-score/${id}`);
      const response = await this.$api.get(`/metrics/customers/${id}/health/full-health-report`);
      return response.data;
    },
 */
    downloadReport() {
      console.log('Exporting report...');
      // Implement export logic
    },
  

  },
};
</script>
